// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__VgYT3","links":"footer_links__2oxZ_","footerLinks":"footer_footerLinks__2tNos"};